import {Box, Button, Container, Divider, Grid, IconButton, List, ListItem, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {Instagram, KeyboardArrowUpRounded, LinkedIn, Twitter} from "@mui/icons-material";

const Footer = () => {
    return (
        <Box component="footer" sx={{ pt: 5, pb: {xs: 2, lg: 1}, color: "#fff", backgroundColor: theme => theme.palette.primary.main}}>
            <Container>
                <Grid container spacing={5}>
                    <Grid item xs={12} lg={3}>
                        <Typography fontSize={{xs: "1rem", lg: "1.2rem"}} fontWeight={500}>دسترسی سریع</Typography>
                        <List>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>مشاهده فایل ها</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>ارسال فایل</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive/request-share">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>درخواست ارسال</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/about-us">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>درباره ما</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="https://mailfa.com/support">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>تماس با ما</Typography>
                                </Link>
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Typography fontSize={{xs: "1rem", lg: "1.2rem"}} fontWeight={500}>آپلود فایل</Typography>
                        <List>
                            <ListItem disableGutters>
                                <Link to="#">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>آپلود سریع</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive/request-share">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>درخواست ارسال</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="#">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>آموزش ارسال</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="#">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>ثبت شکایت</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="#">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>گزارش مشکل</Typography>
                                </Link>
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Typography fontSize={{xs: "1rem", lg: "1.2rem"}} fontWeight={500}>خدمات</Typography>
                        <List>
                            <ListItem disableGutters>
                                <Link to="/drive/settings">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>تغییر مشخصات</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>پنل کاربری</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive/request-share">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>درخواست ارسال</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>اشتراک گذاری</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>ورود به پنل</Typography>
                                </Link>
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <Typography fontSize={{xs: "1rem", lg: "1.2rem"}} fontWeight={500}>دسترسی سریع</Typography>
                        <List>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>مشاهده فایل ها</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>ارسال فایل</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/drive/request-share">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>درخواست ارسال</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="/about-us">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>درباره ما</Typography>
                                </Link>
                            </ListItem>
                            <ListItem disableGutters>
                                <Link to="https://mailfa.com/support">
                                    <Typography fontSize={{xs: ".925rem", lg: ".95rem"}} fontWeight={300}>تماس با ما</Typography>
                                </Link>
                            </ListItem>
                        </List>
                    </Grid>
                </Grid>
            </Container>
            <Divider sx={{ mt: 2, mb: {xs: 2, lg: 1}, borderColor: "#fff", opacity: .3 }}/>
            <Container>
                <Stack direction={{lg: "row"}} alignItems="center" justifyContent={{lg: "space-between"}} spacing={2.5}>
                    <IconButton onClick={() => window.scrollTo({top: 0, behavior: "smooth"})} size="large" sx={{ display: {xs: "none", lg: "flex"}, background: "#90CAF9", color: "#fff", "&:hover": {background: "#6abcff"} }}><KeyboardArrowUpRounded/></IconButton>
                    <Typography mt={{xs: 1.5, lg: 0}} fontSize={{xs: ".825rem", lg: ".875rem"}} fontWeight={300} textAlign="center">تمامی حقوق مادی و معنوی این وب سایت به میلفا تعلق دارد.</Typography>
                    <Stack direction="row" alignItems="center" spacing={3} order={{xs: -1, lg: 0}}>
                        <a href="#">
                            <LinkedIn sx={{ fontSize: {xs: "1.75rem", lg: "1.5rem"} }}/>
                        </a>
                        <a href="#">
                            <Twitter sx={{ fontSize: {xs: "1.75rem", lg: "1.5rem"} }}/>
                        </a>
                        <a href="#">
                            <Instagram sx={{ fontSize: {xs: "1.75rem", lg: "1.5rem"} }}/>
                        </a>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    )
}
export default Footer;
